import { useQuery } from "@apollo/client";
import { CenterResult } from "__legacy/components/CenterResult";
import { CenterSpinner } from "__legacy/components/CenterSpinner";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import { ContactQuery as ContactQueryType, ContactQueryVariables } from "./__generated__/ContactQuery";

const ContactQuery = loader("./ContactQuery.gql");

type ContactQueryProviderType = (props: {
  children: (data: ContactQueryType) => ReactNode;
  variables: ContactQueryVariables;
}) => ReactElement;

export const ContactQueryProvider: ContactQueryProviderType = (props) => {
  const { children, variables } = props;

  const { error, loading, data } = useQuery<ContactQueryType, ContactQueryVariables>(ContactQuery, {
    variables,
    fetchPolicy: "cache-and-network",
  });

  if (loading) return <CenterSpinner size="large" />;
  if (error || !data)
    return <CenterResult status="404" title="404" subTitle="Sorry, the page you visited does not exist." />;

  return <Fragment>{children(data)}</Fragment>;
};
